declare global {
  interface ImportMeta {
    glob(pattern: string, options: { eager: true }): Record<string, unknown>;
  }
}

const models = import.meta.glob('./models/**/*.ts', { eager: true });

export function getCompatModules(modulePrefix: string): Record<string, Record<string, unknown>> {
  const result: Record<string, Record<string, unknown>> = {};

  for (const [path, module] of Object.entries(models)) {
    const normalizedPath = path.replace('./', `${modulePrefix}/`).replace(/\.ts$/, '');
    result[normalizedPath] = module as Record<string, unknown>;
  }

  return result;
}
